<template>
  <div class="idm-promotion-page">
    <!-- Header -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo">
          <img src="../assets/idman_logo.png" class="logo-icon" alt="IDM Logo">
          <span class="logo-text">IDM 下载器</span>
        </div>
        <el-menu 
          mode="horizontal" 
          class="nav-menu" 
          background-color="transparent" 
          text-color="#1890ff"
          active-text-color="#1890ff"
          :default-active="activeMenu"
          @select="handleMenuSelect"
          :ellipsis="false"
        >
          <el-menu-item index="/idmpro" :style="{ color: '#666' }">首页</el-menu-item>
          <el-menu-item index="/order-query" :style="{ color: '#666' }">订单查询</el-menu-item>
          <el-menu-item index="/feedback" :style="{ color: '#666' }">意见反馈</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- New Hero Section based on HTML template -->
    <div class="new-hero-section">


      <div class="block1">
        <div class="backImg">
          <div class="content-wrapper">
            <!-- 左侧：文字区域 -->
            <div class="text-content">
              <h1>IDM 下载器</h1>
              <p class="hero-desc">IDM是一款经典高效的智能多线程下载工具。它通过动态文件分割与加速技术显著提升下载速度，支持断点续传及浏览器集成，并能捕获网页音视频，为您提供稳定流畅的下载体验。</p>
              
              <div class="feature-tags">
                <div class="feature-tag">
                  <el-icon size="20" color="#667eea"><Lightning /></el-icon>
                  <span>极速下载</span>
                </div>
                <div class="feature-tag">
                  <el-icon size="20" color="#667eea"><RefreshLeft /></el-icon>
                  <span>断点续传</span>
                </div>
                <div class="feature-tag">
                  <el-icon size="20" color="#667eea"><ChromeFilled /></el-icon>
                  <span>浏览器集成</span>
                </div>
                <div class="feature-tag">
                  <el-icon size="20" color="#667eea"><List /></el-icon>
                  <span>下载队列</span>
                </div>
                <div class="feature-tag">
                  <el-icon size="20" color="#667eea"><Shield /></el-icon>
                  <span>安全可靠</span>
                </div>
                <div class="feature-tag">
                  <el-icon size="20" color="#667eea"><VideoCamera /></el-icon>
                  <span>视频捕获</span>
                </div>
              </div>

              <div class="main-download-btn" @click="downloadIDM" title="立即下载">
                <span>立即下载</span>
              </div>
              
              <div class="build-time">
                <span>更新时间：</span>
                <span>2026-2-24 18:43:48</span>
              </div>
            </div>

            <!-- 右侧：图片轮播 -->
            <div class="image-content">
              <el-carousel height="520px" :interval="4000" arrow="hover" indicator-position="none" class="hero-carousel">
                <el-carousel-item>
                  <div class="hero-carousel-item">
                    <img src="../assets/idm-preview3.png" alt="IDM 主界面" class="hero-carousel-image">
                  </div>
                </el-carousel-item>
                <el-carousel-item>
                  <div class="hero-carousel-item">
                    <img src="../assets/idm_down_video.png" alt="IDM 视频捕获" class="hero-carousel-image">
                  </div>
                </el-carousel-item>
                <!-- <el-carousel-item>
                  <div class="hero-carousel-item">
                    <img src="../assets/idm-preview3.png" alt="IDM 下载管理" class="hero-carousel-image">
                  </div>
                </el-carousel-item> -->
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    
        <!-- Download Versions -->
    <div class="download-versions-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">选择适合您的版本</h2>
          <p class="section-description">支持多种Windows系统和浏览器</p>
        </div>
        <div class="versions-grid">
          <div class="version-card featured">
            <div class="version-badge">最新版</div>
            <div class="version-icon">
              <img src="../assets/idm.png" alt="IDM" class="version-logo">
            </div>
            <h3>IDM</h3>
            <p class="version-desc">最新版</p>
            <el-button type="primary" size="large" class="version-btn" @click="downloadIDM">
              立即下载
            </el-button>
          </div>
          <div class="version-card">
            <div class="version-icon">
              <img src="../assets/idm.png" alt="IDM" class="version-logo">
            </div>
            <h3>IDM</h3>
            <p class="version-desc">支持Win系统</p>
            <el-button type="primary" size="large" class="version-btn" @click="downloadIDM">
              立即下载
            </el-button>
          </div>
          <div class="version-card">
            <div class="version-icon">
              <img src="../assets/idm.png" alt="IDM" class="version-logo">
            </div>
            <h3>IDM</h3>
            <p class="version-desc">支持Win10/11</p>
            <el-button type="primary" size="large" class="version-btn" @click="downloadIDM">
              立即下载
            </el-button>
          </div>
          <div class="version-card">
            <div class="version-icon">
              <img src="../assets/idm.png" alt="IDM" class="version-logo">
            </div>
            <h3>IDM</h3>
            <p class="version-desc">支持Win8/7</p>
            <el-button type="primary" size="large" class="version-btn" @click="downloadIDM">
              立即下载
            </el-button>
          </div>
          <div class="version-card">
            <div class="version-icon">
              <img src="../assets/idm.png" alt="IDM" class="version-logo">
            </div>
            <h3>IDM</h3>
            <p class="version-desc">支持各浏览器</p>
            <el-button type="primary" size="large" class="version-btn" @click="downloadIDM">
              立即下载
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Advantages Section -->
    <div class="section advantages-section">
      <div class="section-header">
        <h2 class="section-title">完美服务一触即发</h2>
        <p class="section-description">远程安装，极速发货，活动优惠，一键下载</p>
      </div>
      
      <div class="advantages-grid">
        <div class="service-grid">
          <div class="service-item">
            <div class="service-icon">
              <el-icon size="40" color="#667eea"><Monitor /></el-icon>
            </div>
            <h3>远程安装</h3>
            <p>专业技术团队远程协助安装</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <el-icon size="40" color="#667eea"><Timer /></el-icon>
            </div>
            <h3>极速发货</h3>
            <p>下单后立即发送激活码</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <el-icon size="40" color="#667eea"><RefreshLeft /></el-icon>
            </div>
            <h3>支持重装</h3>
            <p>系统重装后可重新激活</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <el-icon size="40" color="#667eea"><Refresh /></el-icon>
            </div>
            <h3>免费更新</h3>
            <p>终身免费更新至最新版本</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Testimonials Section -->
    <div class="section testimonials-section">
      <div class="section-header">
        <h2 class="section-title">用户评价</h2>
        <p class="section-description">听听全球用户对IDM的评价</p>
      </div>
      
      <div class="testimonials-grid">
        <div class="testimonial-card" v-for="(testimonial, index) in testimonials" :key="index">
          <div class="testimonial-content">
            <p>{{ testimonial.content }}</p>
          </div>
          <div class="testimonial-author">
            <div class="author-avatar">{{ testimonial.avatar }}</div>
            <div class="author-info">
              <h4>{{ testimonial.name }}</h4>
              <p>{{ testimonial.role }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FAQ Section -->
    <div class="section faq-section">
      <div class="section-header">
        <h2 class="section-title">常见问题</h2>
        <p class="section-description">您可能关心的问题</p>
      </div>
      
      <div class="faq-container">
        <el-collapse v-model="activeFaq" accordion>
          <el-collapse-item 
            v-for="(faq, index) in faqs" 
            :key="index" 
            :name="index"
            :title="faq.question"
          >
            <p>{{ faq.answer }}</p>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <!-- 客服联系方式 -->
    <div class="customer-service">
      <div class="service-toggle" @click="toggleServicePanel">
        <el-icon><Service /></el-icon>
        <span>{{ isServicePanelOpen ? '收起客服' : '联系客服' }}</span>
      </div>
      <div class="service-content" :class="{ 'expanded': isServicePanelOpen }">
        <div class="service-header">
          <span>客服咨询</span>
        </div>
        <div class="service-body">
          <!-- <div class="qrcode-container">
            <img src="../assets/wechat.png" alt="企业微信二维码" class="qrcode-img">
          </div> -->
          <div class="service-info">
            <!-- <p>企业微信</p> -->
            <a href="https://work.weixin.qq.com/kfid/kfc8d0f9bc2d1044192" target="_blank" class="service-link">
              点击联系客服
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <div class="cta-section">
      <h2>立即体验极速下载</h2>
      <p>提升您的下载体验，享受更快的速度和更稳定的服务</p>
      <el-button type="primary" size="large" class="cta-button" @click="downloadIDM">
        <el-icon><Download /></el-icon>
        立即下载 IDM
      </el-button>
    </div>

    <!-- Footer -->
    <el-footer class="footer">
      <div class="footer-content">
        <p class="copyright">Copyright©2026 51softdown.cn All rights reserved.</p>
        <p class="contact-info">本网站的图文和软件来自于网络，如有内容侵犯您的合法权益，请及时与我们联系，我们会立即删除，联系邮箱: softdown51@outlook.com</p>
        <div class="footer-links">
          <span>信阳市平桥区奇安科技有限公司贵州分公司</span>
          <!-- <span>豫公网安备 XXXXXXXXXX号</span> -->
          <span>豫ICP备2025146548号</span>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { 
  Download,
  Service,
  Monitor,
  Timer,
  RefreshLeft,
  Refresh,
  ChromeFilled,
  Lightning,
  List,
  Shield,
  VideoCamera
} from '@element-plus/icons-vue'

// 路由相关
const route = useRoute()
const router = useRouter()

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  if (route.path === '/order-query') {
    return '/order-query'
  } else if (route.path === '/about') {
    return '/about'
  } else if (route.path === '/idm') {
    return '/idm'
  } else if (route.path === '/idmpro') {
    return '/idmpro'
  } else if (route.path === '/feedback') {
    return '/feedback'
  }
  return '/'
})

// 菜单选择处理
const handleMenuSelect = (key) => {
  if (key === '/') {
    router.push('/')
  } else if (key === '/idm') {
    router.push('/idm')
  } else if (key === '/idmpro') {
    router.push('/idmpro')
  } else if (key === '/order-query') {
    router.push('/order-query')
  } else if (key === '/about') {
    router.push('/about')
  } else if (key === '/feedback') {
    router.push('/feedback')
  }
}


// 下载IDM
const downloadIDM = () => {
  // 发送Umami自定义事件 - IDM下载
  if (window.umami) {
    window.umami.track('download-idm-v6.42', {
      type: 'software',
      name: 'IDM',
      version: 'latest',
      url: 'https://file.51softdown.cn/download/idm/IDM642-Setup.exe'
    });
  }
  
  // 实际的下载逻辑
  window.open('https://file.51softdown.cn/download/idm/IDM642-Setup.exe', '_blank');
}

// 购买IDM
// const buyIDM = () => {
//   // 发送Umami自定义事件 - IDM购买
//   if (window.umami) {
//     window.umami.track('buy-idm', {
//       type: 'software',
//       name: 'IDM',
//       version: 'latest',
//       price: '198'
//     });
//   }
//   // 这里可以添加实际的购买逻辑

//   alert('跳转到购买页面...');
//   // window.open('购买链接', '_blank');
// }

// 用户评价数据
const testimonials = ref([
  {
    content: "IDM彻底改变了我的下载体验。以前需要几小时下载的文件，现在只需几分钟。浏览器集成功能也非常出色，自动捕获下载链接。",
    avatar: "JL",
    name: "张伟",
    role: "软件工程师"
  },
  {
    content: "作为一名内容创作者，我经常需要下载高清视频素材。IDM的视频捕获功能非常强大，几乎可以下载任何网站的视频内容，而且速度惊人。",
    avatar: "ML",
    name: "李敏",
    role: "视频编辑师"
  },
  {
    content: "我已经使用IDM超过5年了，它是我电脑上必不可少的工具之一。断点续传功能在下载大文件时特别有用，再也不用担心网络中断导致下载失败。",
    avatar: "PW",
    name: "王平",
    role: "IT经理"
  }
])

// FAQ数据
const faqs = ref([
  {
    question: "IDM是否支持我的浏览器？",
    answer: "是的，IDM支持所有主流浏览器，包括Google Chrome、Mozilla Firefox、Microsoft Edge、Opera、Safari等。安装IDM后，它会自动集成到您的浏览器中。"
  },
  {
    question: "IDM如何实现加速下载？",
    answer: "IDM通过智能动态文件分段技术加速下载。它将文件分成多个部分，然后同时下载这些部分，最后将它们组合成一个文件。这种方法充分利用了您的可用带宽，使下载速度提高高达5倍。"
  },
  {
    question: "IDM有免费版本吗？",
    answer: "IDM提供30天全功能免费试用。试用期结束后，您需要购买许可证才能继续使用。一次性购买可获得终身免费更新和技术支持。"
  },
  {
    question: "IDM是否安全？",
    answer: "是的，IDM是完全安全的软件。它不包含任何间.spyware、广告软件或恶意代码。IDM还内置了病毒检查功能，可以在下载完成后自动扫描文件。"
  },
  {
    question: "如何更新IDM？",
    answer: "IDM会自动检查更新。当有新版本可用时，它会提示您下载并安装。您也可以通过菜单中的'检查更新'选项手动检查更新。"
  }
])

// 激活的FAQ项
const activeFaq = ref(0)

// 轮播图相关
const currentSlide = ref(0)

// 自动轮播
let carouselInterval = null

// 开始轮播
const startCarousel = () => {
  carouselInterval = setInterval(() => {
    currentSlide.value = (currentSlide.value + 1) % 3; // 循环切换0、1和2
  }, 3000)
}

// 停止轮播
const stopCarousel = () => {
  if (carouselInterval) {
    clearInterval(carouselInterval)
    carouselInterval = null
  }
}

// 组件挂载时开始轮播
import { onMounted, onUnmounted } from 'vue'

onMounted(() => {
  startCarousel()
  
  // 设置页面标题和 favicon
  document.title = 'IDM下载器-官方正版'
  let favicon = document.querySelector('link[rel="icon"]')
  if (favicon) {
    favicon.href = '/idm.ico'
  } else {
    // 如果页面中没有 favicon link 标签，则创建一个
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.href = '/idm.ico'
    document.head.appendChild(favicon)
  }
})

// 客服面板相关
const isServicePanelOpen = ref(false)

const toggleServicePanel = () => {
  isServicePanelOpen.value = !isServicePanelOpen.value
}

onUnmounted(() => {
  stopCarousel()
})
</script>

<style scoped>
.idm-promotion-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f8ff 0%, #e6f3ff 50%, #ffffff 100%);
}

/* Header Styles */
.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #3F414B;
  /* background: linear-gradient(135deg, #1890ff, #40a9ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; */
}

.nav-menu {
  border: none;
  background: transparent !important;
}

.nav-menu .el-menu-item {
  font-weight: 500;
  padding: 0 20px;
  font-size: 16px;
}

/* New Hero Section - Based on HTML template */
.new-hero-section {
  position: relative;
  background: #f5f7fa;
}

/* Navbar Container */
.navbar {
  position: relative;
}

/* 左上角下载中心 */
.download-center-link {
  position: absolute;
  top: 15px;
  left: 20px;
  z-index: 100;
  text-decoration: none;
}

.download-center-link > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.download-center-link .el-icon {
  margin-bottom: 4px;
}

.download-center-link span {
  font-size: 12px;
  color: #333;
}

/* Navigation Bar */
.navbackImg {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-brand img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.nav-brand span {
  font-size: 35px;
  color: white;
  font-weight: 600;
}

.download-button-nav {
  width: 120px;
  height: 40px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
}

.download-button-nav:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
}

.download-button-nav::after {
  content: '立即下载';
}

/* Block 1 - Main Content */
.block1 {
  background: white;
  padding: 0;
}

.backImg {
  background: linear-gradient(135deg, #f8faff 0%, #e8f4f8 100%);
  padding: 60px 0;
}

.content-wrapper {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 60px 0;
}

/* Text Content */
.text-content {
  flex: 0 0 40%;
  max-width: 420px;
  padding-right: 20px;
}

.version-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  color: white;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 20px;
  border-radius: 30px;
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  animation: pulse-badge 2s infinite;
}

@keyframes pulse-badge {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  }
  50% {
    box-shadow: 0 4px 25px rgba(255, 107, 107, 0.5);
  }
}

.text-content h1 {
  font-size: 48px;
  font-weight: 800;
  background: linear-gradient(135deg, #1D2129 0%, #4E5969 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 24px;
  line-height: 1.2;
}

.hero-desc {
  font-size: 18px;
  line-height: 1.8;
  color: #4E5969;
  margin-bottom: 32px;
  text-align: justify;
}

/* Feature Tags - 3x2 Grid Layout */
.feature-tags {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 32px;
}

.feature-tag {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: white;
  padding: 14px 18px;
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(102, 126, 234, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.feature-tag:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.25);
  border-color: transparent;
}

.feature-tag:hover .el-icon {
  color: white !important;
}

.feature-tag:hover span {
  color: white;
}

.feature-tag .el-icon {
  margin-right: 10px;
  font-size: 18px;
  transition: all 0.3s ease;
}

.feature-tag span {
  font-size: 14px;
  color: #4E5969;
  font-weight: 500;
  transition: all 0.3s ease;
}

/* Responsive for feature tags */
@media (max-width: 768px) {
  .feature-tags {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  .feature-tag {
    padding: 12px 16px;
  }
  
  .feature-tag span {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .feature-tags {
    grid-template-columns: 1fr;
  }
}

/* Main Download Button */
.main-download-btn {
  width: 240px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4096FF 0%, #1677FF 50%, #69B1FF 100%);
  background-size: 200% 200%;
  border-radius: 32px;
  cursor: pointer;
  user-select: none;
  color: white;
  font-size: 20px;
  font-weight: 700;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 8px 25px rgba(64, 150, 255, 0.4), 0 4px 10px rgba(64, 150, 255, 0.3);
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
  animation: gradient-shift 3s ease infinite;
}

@keyframes gradient-shift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.main-download-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.main-download-btn:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 35px rgba(64, 150, 255, 0.5), 0 6px 15px rgba(64, 150, 255, 0.4);
}

.main-download-btn:hover::before {
  left: 100%;
}

.main-download-btn:active {
  transform: translateY(-2px) scale(0.98);
}

.main-download-btn span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.main-download-btn span::before {
  content: '⬇';
  font-size: 22px;
  animation: bounce 1.5s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}

/* Build Time */
.build-time {
  margin-top: 24px;
  font-size: 14px;
  color: #86909C;
  display: flex;
  align-items: center;
}

/* Image Content */
.image-content {
  flex: 0 0 60%;
  max-width: 750px;
  text-align: center;
}

.inImg {
  max-width: 120%;
  height: auto;
  -webkit-user-drag: none;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  transform: scale(1.15);
  transition: transform 0.3s ease;
}

.inImg:hover {
  transform: scale(1.2);
}

/* Hero Carousel */
.hero-carousel {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: none;
}

.hero-carousel-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: transparent;
}

.hero-carousel-image {
  max-width: 100%;
  width: 100%;
  height: 100%;
  -webkit-user-drag: none;
  object-fit: contain;
  border-radius: 8px;
}

/* Section Title Bar */
.section-title-bar {
  background: white;
  padding: 40px 0;
  text-align: center;
}

.title-main {
  font-size: 38px;
  color: #1D2129;
  font-weight: 700;
  margin-bottom: 16px;
}

.title-sub {
  font-size: 33px;
  color: #4096FF;
  font-weight: 700;
}

/* Quick Features Section */
.quick-features-section {
  background: white;
  padding: 60px 0;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
}

.quick-features-grid {
  display: flex;
  justify-content: center;
  gap: 80px;
  max-width: 1000px;
  margin: 0 auto;
}

.quick-feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}

.quick-feature-item:hover {
  transform: translateY(-5px);
}

.quick-feature-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.quick-feature-item:hover .quick-feature-icon {
  background: linear-gradient(135deg, #667eea, #764ba2);
}

.quick-feature-item:hover .quick-feature-icon .el-icon {
  color: white !important;
}

.quick-feature-item h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1D2129;
}

/* IDM Intro Section */
.idm-intro-section {
  background: linear-gradient(135deg, #f8faff 0%, #e8f4f8 100%);
  padding: 80px 0;
  text-align: center;
}

.intro-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

.intro-title {
  font-size: 2.5rem;
  font-weight: 800;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 24px;
}

.intro-text {
  font-size: 1.2rem;
  color: #4E5969;
  line-height: 1.9;
  font-weight: 500;
}

/* Download Versions Section */
.download-versions-section {
  background: white;
  padding: 100px 0;
}

.versions-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.version-card {
  background: white;
  border-radius: 20px;
  padding: 32px 20px;
  text-align: center;
  border: 2px solid rgba(102, 126, 234, 0.1);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.version-card:hover {
  transform: translateY(-10px);
  border-color: rgba(102, 126, 234, 0.3);
  box-shadow: 0 20px 50px rgba(102, 126, 234, 0.15);
}

.version-card.featured {
  border-color: #667eea;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05), rgba(118, 75, 162, 0.05));
}

.version-card.featured:hover {
  border-color: #764ba2;
}

.version-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  color: white;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
}

.version-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  transition: all 0.3s ease;
  padding: 15px;
}

.version-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 0.3s ease;
}

.version-card:hover .version-icon {
  background: linear-gradient(135deg, #667eea, #764ba2);
  transform: scale(1.1);
}

.version-card:hover .version-logo {
  transform: scale(1.1);
}

.version-card h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1D2129;
  margin-bottom: 8px;
}

.version-desc {
  font-size: 14px;
  color: #86909C;
  margin-bottom: 20px;
  font-weight: 500;
}

.version-btn {
  width: 100%;
  border-radius: 12px;
  font-weight: 600;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #4096FF 0%, #1677FF 100%);
  border: none;
  color: white;
}

.version-btn:hover {
  transform: scale(1.05);
  background: linear-gradient(135deg, #1677FF 0%, #4096FF 100%);
}

@media (max-width: 1200px) {
  .versions-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .quick-features-grid {
    gap: 40px;
  }
  
  .versions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .quick-features-grid {
    flex-direction: column;
    gap: 30px;
  }
  
  .versions-grid {
    grid-template-columns: 1fr;
  }
  
  .intro-title {
    font-size: 2rem;
  }
}

/* Service Features Section */
.service-features-section {
  background: #ffffff;
  padding: 100px 0;
  position: relative;
}

.service-header {
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  z-index: 1;
}

.service-title {
  font-size: 42px;
  font-weight: 800;
  color: #1D2129;
  margin-bottom: 16px;
}

.service-subtitle {
  font-size: 20px;
  color: #4E5969;
  font-weight: 500;
  letter-spacing: 2px;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.service-item {
  background: white;
  border-radius: 20px;
  padding: 40px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(102, 126, 234, 0.1);
}

.service-item:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 20px 50px rgba(102, 126, 234, 0.15);
  border-color: rgba(102, 126, 234, 0.2);
}

.service-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  transition: all 0.4s ease;
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

.service-item:hover .service-icon {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 12px 30px rgba(102, 126, 234, 0.4);
}

.service-icon .el-icon {
  color: white !important;
}

.service-item h3 {
  font-size: 22px;
  font-weight: 700;
  color: #1D2129;
  margin-bottom: 12px;
}

.service-item p {
  font-size: 15px;
  color: #4E5969;
  line-height: 1.6;
  font-weight: 500;
}

/* Responsive for service features */
@media (max-width: 992px) {
  .service-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 0 20px;
  }
  
  .service-title {
    font-size: 28px;
  }
}

@media (max-width: 576px) {
  .service-grid {
    grid-template-columns: 1fr;
  }
  
  .service-features-section {
    padding: 60px 0;
  }
}

/* Responsive */
@media (max-width: 1320px) {
  .content-wrapper {
    width: 100%;
    padding: 40px 20px;
    flex-direction: column;
    gap: 40px;
  }
  
  .text-content {
    max-width: 100%;
    padding-right: 0;
  }
  
  .image-content {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .nav-brand span {
    font-size: 24px;
  }
  
  .text-content h1 {
    font-size: 28px;
  }
  
  .hero-desc {
    font-size: 16px;
  }
  
  .feature-tag {
    flex: 1 1 100%;
  }
  
  .title-main {
    font-size: 28px;
  }
  
  .title-sub {
    font-size: 24px;
  }
}

/* Hero Section (old styles kept for compatibility) */
.hero-section {
  display: none;
}

/* Logo and Title Container */
.logo-title-container {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
}





/* IDM Logo Styles */
.idm-logo-container {
  flex-shrink: 0;
}

.idm-logo {
  height: 80px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transition: transform 0.3s ease;
}

.idm-logo:hover {
  transform: scale(1.05);
}

/* Hero Title Styles */

.hero-title {
  font-size: 1.60rem;
  line-height: 1.2;

  margin-bottom: 20px;

  font-weight: 700;

  flex: 1;





















}

.hero-title .highlight {
  color: #ffc107;
}

.tagline {
  color: #ffc107;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.hero-description {
  font-size: 1.1rem;
  margin-bottom: 30px;
  opacity: 0.9;
  max-width: 600px;

}

.hero-actions {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.download-btn {
  background-color: #1FB393;
  border-radius: 25px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
  padding: 25px 36px;
  color: #fff;
  letter-spacing: 1px;
  border: 1px solid #1FB393;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition-duration: 1s;
  transition-property: box-shadow, border-color, background-color, color;
  box-shadow: 0 6px 16px rgba(31, 179, 147, 0.3);
  min-width: 180px;
}

.download-btn:hover {
  background-color: #1a9a80;
  border-color: #1a9a80;
  box-shadow: 0 8px 24px rgba(31, 179, 147, 0.4);
  transform: translateY(-2px);
}

.buy-btn {
  background: linear-gradient(135deg, #ff9800, #f57c00);
  border: none;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 30px;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

.buy-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 152, 0, 0.6);
}

.system-info {
  opacity: 0.7;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.hero-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.software-screenshot {
  width: 100%;
  max-width: 821px;
  height: 430px;
  overflow: hidden;
  animation: float 6s ease-in-out infinite;
}

/* 轮播图样式 */
.carousel-container {
  position: relative;
  width: 100%;
  height: 450px; /* 调整高度以更好地展示图片 */
  overflow: hidden;
  background: transparent;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  /* 添加内边距使图片不紧贴边缘 */
  padding: 20px;
  box-sizing: border-box;
}

.carousel-slide.active {
  opacity: 1;
}

.carousel-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  background-color: transparent;
  display: block;
  border: none;
  outline: none;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background: #1FB393;
  transform: scale(1.2);
}

.indicator:hover {
  background: rgba(31, 179, 147, 0.8);
}

.idm-interface {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  display: block;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

/* Section Styles */
.section {
  padding: 100px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 70px;
}

.section-title {
  font-size: 2.8rem;
  font-weight: 800;
  margin-bottom: 20px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-description {
  font-size: 1.25rem;
  max-width: 700px;
  margin: 0 auto;
  color: #4E5969;
  font-weight: 500;
  line-height: 1.6;
}

/* Features Section */
.features-section {
  background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
  padding: 100px 0;
}

.features-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  padding: 0 20px;
}

.feature-card {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: 1px solid rgba(102, 126, 234, 0.1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}

.feature-card:hover {
  transform: translateY(-12px);
  box-shadow: 0 20px 50px rgba(102, 126, 234, 0.15);
}

.feature-card:hover::before {
  transform: scaleX(1);
}

.feature-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  border-radius: 20px;
  font-size: 40px;
  color: #667eea;
  transition: all 0.4s ease;
}

.feature-card:hover .feature-icon {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  transform: scale(1.1) rotate(-5deg);
}

.feature-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1D2129;
}

.feature-description {
  font-size: 1rem;
  color: #4E5969;
  line-height: 1.7;
}

/* Advantages Section */
.advantages-section {
  background: linear-gradient(135deg, #f8faff 0%, #e8f4f8 100%);
  padding: 100px 0;
  position: relative;
}

.advantages-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  padding: 0 20px;
}

.advantage-card {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: 1px solid rgba(102, 126, 234, 0.08);
  position: relative;
  overflow: hidden;
}

.advantage-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}

.advantage-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.12);
}

.advantage-card:hover::after {
  transform: scaleX(1);
}

.advantage-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  color: white;
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
  transition: all 0.4s ease;
}

.advantage-card:hover .advantage-icon {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 12px 30px rgba(102, 126, 234, 0.4);
}

.advantage-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1D2129;
}

.advantage-description {
  font-size: 1rem;
  color: #4E5969;
  line-height: 1.7;
}

/* Carousel Section */
.carousel-section {
  background: linear-gradient(135deg, #f8faff 0%, #e8f4f8 100%);
  padding: 100px 0;
}

.carousel-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

.carousel-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.carousel-image {
  width: 100%;
  height: 320px;
  object-fit: cover;
  object-position: center top;
}

.carousel-caption {
  padding: 20px 30px;
  text-align: center;
  background: white;
  width: 100%;
}

.carousel-caption h3 {
  font-size: 22px;
  font-weight: 700;
  color: #1D2129;
  margin-bottom: 8px;
}

.carousel-caption p {
  font-size: 15px;
  color: #4E5969;
  margin: 0;
}

/* Testimonials Section */
.testimonials-section {
  background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
  padding: 100px 0;
}

.testimonials-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 30px;
  padding: 0 20px;
}

.testimonial-card {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  position: relative;
  border: 1px solid rgba(102, 126, 234, 0.1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.testimonial-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(102, 126, 234, 0.12);
}

.testimonial-card::before {
  content: '"';
  position: absolute;
  top: 20px;
  left: 25px;
  font-size: 70px;
  color: #667eea;
  opacity: 0.15;
  font-family: Georgia, serif;
  line-height: 1;
}

.testimonial-content {
  margin-top: 20px;
  font-style: normal;
  color: #4E5969;
  line-height: 1.9;
  font-size: 1.05rem;
}

.testimonial-content p {
  margin: 0;
}

.testimonial-author {
  display: flex;
  align-items: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(102, 126, 234, 0.1);
}

.author-avatar {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: white;
  margin-right: 16px;
  font-size: 1.1rem;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.author-info h4 {
  font-size: 1.15rem;
  margin-bottom: 6px;
  color: #1D2129;
  font-weight: 700;
}

.author-info p {
  margin: 0;
  font-size: 0.95rem;
  color: #86909C;
  font-weight: 500;
}

/* FAQ Section */
.faq-section {
  background: linear-gradient(135deg, #f8faff 0%, #e8f4f8 100%);
  padding: 100px 0;
}

.faq-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

:deep(.el-collapse) {
  border: none;
}

:deep(.el-collapse-item__header) {
  background: white;
  border: 1px solid rgba(102, 126, 234, 0.15);
  border-radius: 12px;
  padding: 24px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #1D2129;
  margin-bottom: 16px;
  transition: all 0.3s ease;
}

:deep(.el-collapse-item__header:hover) {
  border-color: rgba(102, 126, 234, 0.3);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
}

:deep(.el-collapse-item__wrap) {
  background: white;
  border: 1px solid rgba(102, 126, 234, 0.15);
  border-top: none;
  border-radius: 0 0 12px 12px;
  margin-bottom: 16px;
  margin-top: -16px;
}

:deep(.el-collapse-item__content) {
  padding: 24px;
  color: #4E5969;
  line-height: 1.9;
  font-size: 1.05rem;
}

/* CTA Section */
.cta-section {
  text-align: center;
  padding: 120px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 60%);
  animation: rotate 30s linear infinite;
}

.cta-section h2 {
  font-size: 3rem;
  margin-bottom: 24px;
  font-weight: 800;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.cta-section p {
  font-size: 1.25rem;
  max-width: 700px;
  margin: 0 auto 50px;
  opacity: 0.95;
  position: relative;
  z-index: 1;
  line-height: 1.7;
}

.cta-button {
  background: linear-gradient(135deg, #4096FF 0%, #1677FF 100%);
  border-radius: 50px;
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  text-align: center;
  padding: 22px 50px;
  color: #fff;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(64, 150, 255, 0.4);
  min-width: 240px;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.cta-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.cta-button:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 15px 40px rgba(64, 150, 255, 0.5);
}

.cta-button:hover::before {
  left: 100%;
}

.cta-button:active {
  transform: translateY(-2px) scale(0.98);
}

/* Footer */
.footer {
  background: linear-gradient(180deg, #1D2129 0%, #2d3142 100%);
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  padding: 60px 0 40px;
  height: auto !important;
  border-top: none;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.copyright {
  margin: 0 0 16px 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.contact-info {
  margin: 0 0 16px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 30px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  flex-wrap: wrap;
}

/* 客服联系方式 */
.customer-service {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
}

.service-toggle {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: white;
  text-align: center;
  padding: 12px 0;
  font-weight: bold;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  width: 180px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  font-size: 14px;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.service-toggle:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  box-shadow: 0 6px 24px rgba(24, 144, 255, 0.3);
  transform: translateY(-2px);
}

.service-content {
  background: white;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 180px;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease;
}

.service-content.expanded {
  max-height: 300px;
}

.service-header {
  background: #1890ff;
  color: white;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}

.service-body {
  padding: 15px;
}

.qrcode-container {
  text-align: center;
  margin-bottom: 15px;
}

.qrcode-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.service-info {
  text-align: center;
}

.service-info p {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

.service-link {
  display: inline-block;
  background: #1890ff;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12px;
  margin-top: 5px;
  transition: background 0.3s;
}

.service-link:hover {
  background: #40a9ff;
}

/* Responsive */
@media (max-width: 768px) {
  .customer-service {
    display: none;
  }
  
  .hero-content {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }
  
  .hero-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .hero-title {
    font-size: 2.2rem;
  }
  
  .features-grid,
  .advantages-grid,
  .testimonials-grid {
    grid-template-columns: 1fr;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 10px;
  }
}
</style>